<template>
    <div class="page">
        <p>{{ date }}</p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            SSN: {{ userStore.user.ssn }} | DOB: {{ userStore.user.dob }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p>
            <template v-if="creditBureau.officers">
                <strong>Attn:</strong> {{ creditBureau.officers }} <br />
            </template>
        </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            This letter is in response to your computer-generated letter dated <strong>{{ originalDisputeDate != null ? moment(originalDisputeDate).format('LL') : '(Insert Date)' }}</strong>.
            Your letter states that you have decided to cease the investigation of the incorrect
            items I have reported to you because in your opinion I am the client of a third-party
            credit repair agency.
        </p>
        <p class="letter-content">
        You were advised by me on my letter dated <strong>{{ dateAccountRemoved != null ? moment(dateAccountRemoved).format('LL'):'(Insert Date)' }}</strong> (copy enclosed) to investigate a few things that I believe are inaccurate. That request was
        written by me and mailed by me-not a third party agency.
        </p>
        <p class="letter-content">
        It appears obvious to me that you are abusing your power under the FCRA to escape a complete investigation.
        And FYI, I did some research on the matter and found that there is no law forbidding a consumer from using a
        credit repair agency, which makes your response even more absurd!
        </p>
        <p class="letter-content">
        As a matter of fact, Congress has found the process so overwhelming that they specifically afford consumers
        the right to use a third party agency on their behalf if they so choose. Congress also reserves my right to
        sue a credit bureau for violations of the FCRA.
        </p>
        <p class="letter-content">
        I believe I can prove that you did not use reasonable measures to insure the accuracy of my credit reports
        and you are now stalling the process further. I realize disputes may be expensive and therefore it is your
        job to stall them but you do so at great risk.
        </p>
        <p class="letter-content">
        Please take notice that this letter dated <strong>{{date}}</strong> is a formal notice to you that I am requesting for you
        continue moving forward with my original investigation request.
        </p>
        <p class="letter-content">
        Send the results to me within 15 days. I therefore legally and lawfully refuse your "form letter" thus giving
        you only 15 days, not 30 more.
        </p>
        <p class="letter-content">
        I am outraged at your accusation and I have fully researched my rights in regard to my credit file. I look forward
        to your expediting my original request immediately.

        </p>

        <P class="letter-content">
            Enclosed is a list of accounts that you claimed were “verified”. Thank you for your prompt attention to this matter.
        </P>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
                <template v-if="creditor.reason">
                    <br />
                    {{ creditor.reason }}
                </template>
            </strong>
        </p>

        <p>
            Best Regards,
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
            originalDisputeDate: {
                type: String
            },
            dateAccountRemoved: {
                type: String
            },
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                moment:moment,
                address,
            };
        },
    };
</script>
